// eslint-disable-next-line max-len
import feathersClient, { makeServicePlugin, BaseModel, makeServiceStore } from '../../feathers-client';

const servicePath = 'parts';

const Model = class Part extends BaseModel {
  static modelName = 'Part';

  static instanceDefaults() {
    return {
      EstimateLineStatus: {
        isDrawingUploaded: false,
        isDrawingUploadedMsg: '',
        isManufacturable: false,
        isManufacturableMsg: '',
        isAnalysed: false,
        isAnalysedMsg: '',
        isFinishSelected: false,
        isFinishSelectedMsg: '',
        isThumbnailUploaded: false,
        isThumbnailUploadedMsg: '',
        isObjUploaded: false,
        isObjUploadedMsg: '',
        isDxfUploaded: false,
        isDxfUploadedMsg: '',
      }
    }
  }
};

export default {
  plugin: makeServicePlugin({
    servicePath,
    service: feathersClient.service(servicePath),
    Model,
  }),

  store: makeServiceStore({ servicePath, Model }),
};
